<div *ngIf="vm.isOpen && vm.bodyPartSymptomNames">
        <div class="symptom-popover" *ngFor="let bodyPartSymptom of vm.bodyPartSymptomNames | keyvalue">
            <button type="button" class="symptom-popover__close" id="closePopUpInfoButton" (click)="vm.handleCloseButtonClick()">
                <i class="o-icon o-icon--x" aria-hidden="true"></i>
                <span class="u-sr-only">{{ 'Common.Close' | translate }}</span>
            </button>
            <h4>{{ vm.getTranslatedBodyPart(bodyPartSymptom.key)}} </h4>
            <ul>
                <li *ngFor="let symptom of bodyPartSymptom.value"
                    (click)="vm.toggleSymptomSelection(symptom)"
                    [ngClass]="{'selected': vm.isSelected(symptom)}">
                    {{ symptom.name }}
                </li>
            </ul>
            <div class="disclaimer-box">
                <i class="o-icon o-icon--info" style="margin-right: 2px; margin-bottom: 20px;"></i>
                <span>{{ 'Symptom_Check.Use_Search_Box' | translate }}</span>
            </div>
        </div>
</div>